(() => {
  const guideSelector = '[data-rd-transition-guide]';

  if (window.RDTransitionGuide) {
    window.RDTransitionGuide.init(document);
    return;
  }

  const initializeGuide = (guide) => {
    if (!guide || guide.dataset.rdTransitionInitialized === 'true') return;

    const sizeSelect = guide.querySelector('[data-rd-transition-size]');
    const paceSelect = guide.querySelector('[data-rd-transition-pace]');
    const steps = Array.from(guide.querySelectorAll('[data-rd-transition-step]'));
    const amounts = Array.from(guide.querySelectorAll('[data-rd-transition-amount]'));
    const dogLabels = Array.from(guide.querySelectorAll('[data-rd-transition-dog-label]'));

    const updateGuide = () => {
      const selectedOption = sizeSelect?.selectedOptions?.[0];
      const pace = paceSelect?.value === 'gentle' ? 'gentle' : 'standard';

      steps.forEach((step) => {
        const days = step.querySelector('[data-rd-transition-days]');
        const nextLabel = step.dataset[`${pace}Days`];
        if (days && nextLabel) days.textContent = nextLabel;
      });

      if (selectedOption) {
        amounts.forEach((amount) => {
          const phase = amount.dataset.rdTransitionAmount;
          const value = selectedOption.getAttribute(`data-amount-${phase}`);
          if (value) amount.textContent = value;
        });

        dogLabels.forEach((label) => {
          label.textContent = selectedOption.dataset.dogLabel || selectedOption.textContent.trim();
        });
      }
    };

    sizeSelect?.addEventListener('change', updateGuide);
    paceSelect?.addEventListener('change', updateGuide);
    guide.dataset.rdTransitionInitialized = 'true';
    updateGuide();
  };

  const init = (root = document) => {
    if (root.matches?.(guideSelector)) initializeGuide(root);
    root.querySelectorAll?.(guideSelector).forEach(initializeGuide);
  };

  window.RDTransitionGuide = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => init(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
